@if (formCtrl().value && formCtrl().errors?.['email'] && (formCtrl().dirty || formCtrl().touched)) {
  <small class="error-info text-error">
    {{ errorMsg }}
  </small>
}
